/**
 * Legale Split-Punkte eines Tages-Segments im Stunden-Grid (Ticket: „Schere
 * soll eingeblendet werden wenn über Mitternacht").
 *
 * Zu den ECHTEN Eintragsgrenzen (Start-/End-Tag) braucht der Trennpunkt
 * SNAP-Abstand, damit keine Null-Länge-Hälfte entsteht. Eine TAGESGRENZE ist
 * dagegen selbst legal: Ein Eintrag 23:00–01:00 wird am Start-Tag bis exakt
 * 24:00 bzw. am End-Tag ab exakt 00:00 geteilt — der kanonische
 * Mitternachts-Split, der vorher durch die pauschale ±15-min-Klemme
 * unmöglich war. null = Segment hat keinen legalen Punkt (die Schere zeigt
 * dann einen Disabled-Zustand statt stumm nichts zu tun).
 */
export function splitRangeForSegment(
  segStartMins: number,
  segEndMins: number,
  isStartDay: boolean,
  isEndDay: boolean,
  snap = 15,
): { minMins: number; maxMins: number } | null {
  const minMins = isStartDay ? segStartMins + snap : segStartMins
  const maxMins = isEndDay ? segEndMins - snap : segEndMins
  if (maxMins < minMins) return null
  return { minMins, maxMins }
}
